import {
  DayPicker as DayPickerBase,
  DayPickerProps,
  getDefaultClassNames,
  MonthCaptionProps,
  Chevron,
  useDayPicker,
  ClassNames,
} from '@daypicker/react';

const CustomMonthCaption = (props: MonthCaptionProps) => {
  const {
    children,
    className = '',
    'data-animated-caption': dataAnimatedCaption,
    style,
  } = props as MonthCaptionProps & { 'data-animated-caption'?: string };

  const { previousMonth, nextMonth, goToMonth } = useDayPicker();

  return (
    <div
      className={`${className} flex items-center justify-between px-sm pb-lg h-auto`}
      style={style}
    >
      <button
        type="button"
        disabled={!previousMonth}
        onClick={() => previousMonth && goToMonth(previousMonth)}
        className="p-xs rounded-sm text-textLight disabled:opacity-30 hover:text-main transition-default active:shadow-sm"
      >
        <Chevron orientation="left" size={16} className="fill-current" />
      </button>

      <span
        data-animated-caption={dataAnimatedCaption}
        className="text-medium text-text font-medium"
      >
        {children}
      </span>

      <button
        type="button"
        disabled={!nextMonth}
        onClick={() => nextMonth && goToMonth(nextMonth)}
        className="p-xs rounded-sm text-textLight disabled:opacity-30 hover:text-main transition-default active:shadow-sm"
      >
        <Chevron orientation="right" size={16} className="fill-current" />
      </button>
    </div>
  );
};

const CustomNav = () => <></>;

const mergeClassNames = (classNamesProps?: Partial<ClassNames>): ClassNames => {
  const defaultClassNames = getDefaultClassNames();

  defaultClassNames.root = `${defaultClassNames.root} sp-daypicker`;

  if (!classNamesProps) {
    return defaultClassNames;
  }

  Object.keys(classNamesProps).forEach(key => {
    const className = key as keyof ClassNames;

    defaultClassNames[className] =
      `${defaultClassNames[className]} ${classNamesProps[className]}`;
  });

  return defaultClassNames;
};

export const DayPicker = (props: DayPickerProps) => {
  return (
    <DayPickerBase
      animate
      fixedWeeks
      showOutsideDays
      weekStartsOn={1}
      {...props}
      classNames={mergeClassNames(props.classNames)}
      components={{
        Nav: CustomNav,
        MonthCaption: CustomMonthCaption,
      }}
    />
  );
};
